var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"favorite-sales-items"},_vm._l((_vm.favoriteSalesItems),function(item,index){return _c('div',{staticClass:"sale-item"},[_c('saleItem',{attrs:{"salesArr":item,"saleItemIndex":index,"saleItemsParentPage":'promo'}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }